import React, { HTMLAttributes, HTMLProps } from 'react';
import Immutable from 'immutable';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Button, Video } from '../../../components';
import useClasses from '../../../hooks/useClasses';
import type { ImmutableParagraphTextVideoEntity } from '..';

import './style.scss';

interface Props extends HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableParagraphTextVideoEntity;
  index?: number;
}

const ParagraphTextVideo: React.FC<Props> = ({
  entity,
  className,
  index,
}) => {
  const { buildClass, joinClasses } = useClasses('ParagraphTextVideo');

  const title = entity.getIn(['field_title', 0, 'value'], '');
  const body = entity.getIn(['field_text', 0, 'processed'], '');
  const link = entity.getIn(['field_link', 0], Immutable.Map());
  const video = String(entity.getIn(['field_media_item', 0, 'embed'], ''));

  const orderClassesMedia = 'order-lg-2 offset-lg-1 order-md-2 order-sm-1 offset-md-0 media';
  const orderClassesContent = 'order-lg-1 order-md-1 order-sm-1 offset-md-0 content';

  const gridClassesMedia = `col-lg-5 col-md-6 col-sm-12 col-12 ${(index % 2 === 1) ? orderClassesMedia : orderClassesContent}`;
  const gridClassesContent = `col-lg-6 col-md-6 col-sm-12 col-12 ${(index % 2 === 1) ? orderClassesContent : orderClassesMedia}`;

  return (
    <article className={joinClasses(className, buildClass())}>
      <div className="row">
        <div className={joinClasses(buildClass('content-container'), gridClassesContent)}>
          <div className={buildClass('content')}>
            <div className={buildClass('title')}>
              <h2>{title}</h2>
            </div>

            <div className={buildClass('body')}>
              <WysiwygField
                property="schema:text"
                html={body}
              />
            </div>

            {link.size > 0 && (
              <Button href={link.get('uri')} secondary className={buildClass('link')}>
                {link.get('title')}
              </Button>
            )}
          </div>
        </div>
        <div className={joinClasses(buildClass('media-container'), gridClassesMedia)}>
          <div className={buildClass('video')}>
            { video && <Video url={video} className={buildClass('video')} /> }
          </div>
        </div>
      </div>
    </article>
  );
};

export default ParagraphTextVideo;
